import { createApi } from '@reduxjs/toolkit/query/react';
import { idType } from '@src/types';
import { baseQuerySample } from '@store/helpers';
import { format } from 'date-fns';

type filterType = {
  operator: string;
  value: {};
  values: Array<{}>;
};

export type getRidesByAssignedResType = {
  content: Array<{
    id: idType;
    contractor: string;
    dropOfCityZipcode: string;
    member: string;
    miles: number;
    pickUpCityZipcode: string;
    pickUpCounty: string;
    pickUpTime: string;
    rideOrderConfirmationCode: string;
    service: string;
    status: string;
    statusId: idType;
  }>;
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
  filter: {
    additionalProp1: filterType;
    additionalProp2: filterType;
    additionalProp3: filterType;
  };
  sortDir: 'asc' | 'desc';
  sortBy: string;
  table: string;
};

export type filterBodyTypes = {
  rideRequestDate?: string;
  startDate?: string;
  endDate?: string;
  state?: number;
  statusId?: Array<number>;
};

export const monitoringApi = createApi({
  reducerPath: 'Monitoring',
  tagTypes: ['Monitoring'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getRidesByAssigned: builder.mutation<
      getRidesByAssignedResType,
      {
        body?: filterBodyTypes;
        params?: Record<string, string>;
      }
    >({
      query: ({ body = {}, params = {} }) => ({
        url: `/v1/search/ride?`,
        method: 'POST',
        body: {
          rideRequestDate: format(Date.now(), 'MM/dd/yyyy'),
          startDate: '00:00',
          endDate: '23:59',
          ...body,
        },
        params: {
          page: 0,
          size: 20,
          sortBy: 'rideDate',
          sortDir: 'desc',
          ...params,
        },
      }),
    }),
    getSegmentDetailsById: builder.query({
      query: ({ id, isPortalVersion = false }) => ({
        url: isPortalVersion
          ? `/v2/rides/assignment/contractor-portal/segment/${id}`
          : `/v2/rides/assignment/segment/${id}`,
      }),
    }),
  }),
});

export const {
  useGetRidesByAssignedMutation,
  useLazyGetSegmentDetailsByIdQuery,
} = monitoringApi;
